import { atlas } from 'graphql/tags'

export const ORDER_CONTACTS = atlas`#graphql
  query orderContactsDupe1($orderIds: [ID!]) {
    orders(filters: { ids: $orderIds }) {
      edges {
        node {
          id
          referenceNumber
          buyer {
            id
            name
            email
          }
        }
      }
    }
  }
`
